import { render, staticRenderFns } from "./bookingspace_digital.vue?vue&type=template&id=020369cb"
import script from "./bookingspace_digital.vue?vue&type=script&lang=js"
export * from "./bookingspace_digital.vue?vue&type=script&lang=js"
import style0 from "./bookingspace_digital.vue?vue&type=style&index=0&id=020369cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports